import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { Ciudad, RequestResponseGetAllCiudad, RequestResponseActualizar, RequestResponseGetAllCiudadRegion } from 'src/app/shared/models/ciudades.interface';


@Injectable({
  providedIn: 'root'
})
export class CiudadService {

  constructor(
    private http:HttpClient,
    private router: Router,
    private alert:AlertHelper)
   { }
    //GetAll_ciudades
  traerCiudades(): Observable<RequestResponseGetAllCiudad> {
    return this.http
    .get<RequestResponseGetAllCiudad >(`${environment.API}/rrhh/ciudad/`)
    .pipe(
      map((res:RequestResponseGetAllCiudad) =>{          
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //GetAll_ciudadesRegiones
  traerCiudadesRegiones(): Observable<RequestResponseGetAllCiudadRegion> {
    return this.http
    .get<RequestResponseGetAllCiudadRegion >(`${environment.API}/rrhh/ciudad/ciudadesregiones`)
    .pipe(
      map((res:RequestResponseGetAllCiudadRegion) =>{          
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //GetAllCiudadesRegionesAsync
  async traerCiudadesRegionesAsync(): Promise<RequestResponseGetAllCiudadRegion> {
    try {
      return await this.http.get<RequestResponseGetAllCiudadRegion>(`${environment.API}/rrhh/ciudad/ciudadesregiones`).toPromise();
    } catch (error) {
      console.error(error);
      return ({success: false, msg: 'Hubo un error al obtener las ciudades y regiones.'} as RequestResponseGetAllCiudadRegion)
    }
  }
  //Create_ciudad
  crearCiudad(ciudad:Ciudad): Observable<RequestResponse> {      
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/ciudad/crear`,ciudad)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_ciudad
  actualizarCiudad(ciudad:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/ciudad/actualizar/${ciudad.id}`,ciudad)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_ciudad
  traerCiudadPorId(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/ciudad/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_ciudadRegion
  traerCiudadesRegionesId(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse>(`${environment.API}/rrhh/ciudad/ciudadesregiones/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //ObtenerCiudadRegionAsync
  async traerCiudadesRegionesIdAsync(id: number): Promise<RequestResponse> {
    try {
      return await this.http.get<RequestResponse>(`${environment.API}/rrhh/ciudad/ciudadesregiones/${id}`).toPromise();
    } catch (error) {
      console.error(error);
      return ({success: false, msg: 'Ocurrio un error al obtener la ciudad y región'} as RequestResponse)
    }
  }

  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
  //Eliminar_Ciudad
  eliminarCiudad(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/ciudad/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }

}




